import { render, staticRenderFns } from "./FormEvento.vue?vue&type=template&id=1912623b"
import script from "./FormEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEvento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports